var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0.636719C43.1125 0.636719 55.3633 12.8875 55.3633 28C55.3633 43.1125 43.1125 55.3633 28 55.3633C12.8875 55.3633 0.636719 43.1125 0.636719 28C0.636719 12.8875 12.8875 0.636719 28 0.636719Z",
    fill: "#EC4E22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 0.636719C43.1125 0.636719 55.3633 12.8875 55.3633 28C55.3633 43.1125 43.1125 55.3633 28 55.3633C12.8875 55.3633 0.636719 43.1125 0.636719 28C0.636719 12.8875 12.8875 0.636719 28 0.636719Z",
    stroke: "#EC4E22",
    strokeWidth: 1.27273,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 15.5,
    width: 25,
    height: 25,
    fill: "#FFF8F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.bbb8f26e6831106b8811dc6e440538a2.svg";
export { ForwardRef as ReactComponent };